import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import TextArea from 'components/_parts/atoms/textArea';
import { useMutationSkillGroupManagement } from 'components/company/api/useCompetencyAndSkillGroup';
import { preparePayloadSkillGroup } from 'components/company/utils/preparePayload';
import { useFormik } from 'formik';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import CollapsibleEdit from './collapsibleEdit';
import './index.scss';
import initialValues from './initialValues';
import { validationSchemaData } from './validationSchema';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
  margin-left: 6px;
`;

function SkillComp(props) {
  const { typeForm, dataEdit } = props;
  const { t } = props;
  const [isOpen, setIsOpen] = useState(0);

  const { mutate: mutationSkillGroupManagement } = useMutationSkillGroupManagement();

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchemaData({ type: props?.typeForm, t }),
    onSubmit: (values) => {
      const payloadSkillGroup = preparePayloadSkillGroup(values, typeForm);

      mutationSkillGroupManagement(payloadSkillGroup);

      props.funcModal(false);
      formik.resetForm();
    },
  });

  const handleAdd = (index) => {
    const dataUpdate = [...formik.values.data.sub_skill_group, initialValues.data.sub_skill_group[0]];

    formik.setFieldValue('data.sub_skill_group', dataUpdate);
    setIsOpen(index + 1);
  };

  const handleRemove = (index) => {
    const dataUpdate = [...formik.values.data.sub_skill_group];
    dataUpdate.splice(index, 1);

    formik.setFieldValue('data.sub_skill_group', dataUpdate);
  };

  const handleChange = (e, fieldName) => {
    formik.setFieldValue(fieldName, e.target.value);
  };

  return (
    props?.modal
        && createPortal(
          <>
            <FullScreenOverlay
              className="cs_modal-bg"
              onClick={() => {
                props?.funcModal(false);
                formik.resetForm();
              }}
            />
            <form
              className="cs_modal-groupManagement"
              ref={props.innerRef}
              onSubmit={formik.handleSubmit}
            >
              {typeForm === 'create' && (
                <div className="cs_modal-groupManagement-left">
                  <div className="d-flex justify-content-between py-2">
                    <Label
                      className="text-center"
                      typeLabel="label_modal"
                      style={{
                        fontSize: '16px',
                      }}
                    >
                      {`${props?.typeForm === 'edit' ? t('org.structure_view.modal.edit') : t('org.structure_view.modal.add')} Skill Group Management`}
                    </Label>

                    <div>
                      <ButtonMod
                        func={formik.handleSubmit}
                      >
                        {t('board.save')}
                      </ButtonMod>
                      <ButtonMod
                        func={() => {
                          props?.funcModal(false);
                          formik.resetForm();
                        }}
                      >
                        {t('board.cancel')}
                      </ButtonMod>
                    </div>
                  </div>

                  <div className="mt-3">
                    <Input
                      name="data.skill_group_name"
                      type="text"
                      style={{ width: '70%' }}
                      value={formik.values?.data?.skill_group_name || ''}
                      placeholder="Input Skill Group Name"
                      onChange={formik.handleChange}
                      isError={formik.errors.data?.skill_group_name}
                      validateMessage={formik.errors.data?.skill_group_name}
                    />
                  </div>
                  <div className="mt-3">
                    <TextArea
                      id="id-skillGroupDesc"
                      name="data.skill_group_description"
                      placeholder="Input Skill Group Description"
                      className="center_placeholder scrollCustom"
                      style={{ resize: 'none' }}
                      rows={3}
                      value={formik.values.data.skill_group_description || ''}
                      onChange={(e) => handleChange(e, 'data.skill_group_description')}
                      isError={formik.errors.data?.skill_group_description}
                      validateMessage={formik.errors.data?.skill_group_description}
                    />
                  </div>
                  <div
                    style={{ height: '100%', overflow: 'auto', padding: '10px 5px' }}
                  >
                    {formik.values?.data?.sub_skill_group?.map((item, i) => (
                      <div
                        key={i + 1}
                        className="cs_modal-groupManagement-left-form-subSkill"
                      >
                        <div
                          className="competency_lib-right-form-input my-2"
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            columnGap: '11px',
                          }}
                        >
                          <div style={{ width: '70%' }}>
                            <Label
                              className=""
                              typeLabel="f14w400"
                            >
                              Sub Skill Group
                            </Label>
                          </div>

                          <div className="d-flex gap10px">
                            {formik.values.data?.sub_skill_group?.length > 1 && (
                            <Button
                              icon="minus"
                              style={{ height: '24px', width: '26px', backgroundColor: '#FF4F4F' }}
                              func={() => handleRemove(i)}
                            />
                            )}
                            <Button
                              icon="create"
                              style={{
                                height: '24px',
                                width: '26px',
                                backgroundColor: '#9AFF5B',
                                visibility: i === formik.values.data?.sub_skill_group?.length - 1 ? '' : 'hidden',
                              }}
                              func={() => handleAdd(i)}
                            />
                            <Button
                              icon={`${isOpen === i ? 'down' : 'chevronRight'}`}
                              style={{
                                height: '24px', width: '26px', backgroundColor: 'white', color: '#4C4C4C',
                              }}
                              func={() => (isOpen === i ? setIsOpen(null) : setIsOpen(i))}
                            />
                          </div>
                        </div>

                        <div
                          className="competency_lib-right-form-btn d-flex mt-3"
                          style={{
                            columnGap: '5px',
                          }}
                        >
                          { isOpen === i && (
                          <div className="w-100 h-100">
                            <div className="mt-3 w-100">
                              <Input
                                name={`data.sub_skill_group[${i}].sub_skill_group_name`}
                                type="text"
                                style={{ width: '70%' }}
                                value={formik.values.data?.sub_skill_group[i].sub_skill_group_name || ''}
                                placeholder="Input Sub Skill Group Name"
                                onChange={formik.handleChange}
                                isError={formik.errors?.data?.sub_skill_group?.[i]?.sub_skill_group_name}
                                validateMessage={formik.errors.data?.sub_skill_group?.[i]?.sub_skill_group_name}
                              />
                              <div className="mt-3">
                                <TextArea
                                  id="id-subSkillGroupDesc"
                                  name={`data.sub_skill_group[${i}].sub_skill_group_description`}
                                  placeholder="Input Sub Skill Group Description"
                                  className="center_placeholder"
                                  style={{ resize: 'none' }}
                                  rows={3}
                                  value={formik.values.data?.sub_skill_group[i].sub_skill_group_description || ''}
                                  onChange={(e) => handleChange(e, `data.sub_skill_group[${i}].sub_skill_group_description`)}
                                  isError={formik.errors.data?.sub_skill_group?.[i]?.sub_skill_group_description}
                                  validateMessage={formik.errors.data?.sub_skill_group?.[i]?.sub_skill_group_description}
                                />
                              </div>
                            </div>
                          </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {typeForm === 'update' && (
              <div
                className="cs_modal-groupManagement-right"
              >
                <div className="d-flex justify-content-between pb-2 mb-3" style={{ gap: '10px' }}>
                  <Label
                    className="mt-2"
                    typeLabel="label_modal"
                  >
                    Edit Skill Group Management
                  </Label>
                  <div>
                    <ButtonMod
                      func={formik.handleSubmit}
                    >
                      {t('board.save')}
                    </ButtonMod>
                    <ButtonMod
                      func={() => {
                        props?.funcModal(false);
                        formik.resetForm();
                      }}
                    >
                      {t('board.cancel')}
                    </ButtonMod>
                  </div>
                </div>
                <CollapsibleEdit
                  data={dataEdit}
                  formik={formik}
                  t={t}
                  typeForm={typeForm}
                />
              </div>
              )}
            </form>
          </>,
          document.getElementById('pop_up-parent'),
        )
  );
}

export default SkillComp;
